/**
 * Picks v2 or v1 of the Marketing Initiatives list based on the
 * redesign flag.
 */
import React from 'react';
import { useRedesignFlag } from '../../../utils/redesignFlag';
import MarketingInitiativePage   from './MarketingInitiativePage';
import MarketingInitiativePageV2 from './v2/MarketingInitiativePageV2';

export default function MarketingInitiativePageSwitch(props) {
  const [v2] = useRedesignFlag();
  const Component = v2 ? MarketingInitiativePageV2 : MarketingInitiativePage;
  return <Component {...props} />;
}
